module.exports = __webpack_public_path__ + "static/media/vi.067cf579.svg";